export const navigationName = {
  "/board/dashboard": "홈/대시보드",
  "/board/media": "홈/지면 관리/지면 등록",
  "/board/mediaList": "홈/지면 관리/지면 리스트",
  "/board/mediaListDetail": "홈/지면 관리/지면 상세",
  "/board/reports": "홈/보고서/일자별 보고서",
  "/board/reportsHour": "홈/보고서/시간대별 보고서",
  "/board/reportsMedia": "홈/보고서/매체별 보고서",
  "/board/reportsInventory": "홈/보고서/지면별 보고서",
  "/board/reportsAdExchange": "홈/보고서/외부 연동 수신 보고서",
  "/board/notice": "홈/지원/공지사항",
  "/board/noticeDetail": "홈/지원/공지사항 상세",
  "/board/inquiry": "홈/지원/1:1 문의",
  "/board/inquiryDetail": "홈/지원/1:1 문의 상세",
  "/board/platformAdmin": "홈/플랫폼 관리/관리자 관리",
  "/board/platformAdminDetail": "홈/플랫폼 관리/관리자 생성",
  "/board/platform": "홈/플랫폼 관리/사용자 관리",
  "/board/platformUserDetail": "홈/플랫폼 관리/사용자 관리 상세",
  "/board/platformTerm": "홈/플랫폼 관리/약관 관리",
  "/board/platformTermDetail": "홈/플랫폼 관리/약관 관리 상세",
  "/board/platformHistory": "홈/플랫폼 관리/광고 이력 관리",
  "/board/platformAdExchange": "홈/플랫폼 관리/애드 익스체인지 이력 관리",
  "/board/platformHistoryDetail": "홈/플랫폼 관리/광고 이력 관리 상세",
  "/board/platformAdExchangeDetail": "홈/플랫폼 관리/애드 익스체인지 이력 관리 상세",
  "/board/myPageUser": "홈/마이페이지",
  "/board/myPageAdmin": "홈/마이페이지",
  "/board/apiGuide": "홈/API 연동 가이드",
  "/board/adExchange": "홈/애드 익스체인지 관리/지면 연동",
  "/board/adExchangeDetail": "홈/애드 익스체인지 관리/지면 연동 상세",
  "/board/adExchangeInventoryDetail": "홈/애드 익스체인지 관리/송출 연동",
  "/board/account": "홈/정산 관리/정산 정보",
  "/board/accountHistory": "홈/정산 관리/정산 이력",
  "/board/accountProfile": "홈/정산 관리/정산 프로필 관리",
  "/board/accountConfirm": "홈/정산 관리/정산 심사",
  "/board/accountData": "홈/정산 관리/데이터 관리",
};

export const dataTotalInfo = {
  totalCount: 1,
  totalPages: 1,
  currentPage: 1,
};
